import { FILTER_TYPES, PAGE_SIZE_FILTER } from 'constants/filterType';

export const RETURN_MANIFEST_FILTER_OPTIONS = [
  {
    field: 'return_manifest_code__icontains',
    label: 'Return Manifest Code',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'return_manifest_status',
    label: 'Return Manifest Status',
    type: FILTER_TYPES.MULTI_SELECT,
    options: [
      { value: 'created', label: 'Created' },
      { value: 'closed', label: 'Closed' },
      { value: 'discarded', label: 'Discarded' },
      { value: 'pending', label: 'Pending' },
    ],
  },
  {
    field: 'created_after',
    label: 'Created After',
    type: FILTER_TYPES.DATE,
  },
  {
    field: 'created_before',
    label: 'Created Before',
    type: FILTER_TYPES.DATE,
  },
  {
    field: 'modified_after',
    label: 'Modified After',
    type: FILTER_TYPES.DATE,
  },
  {
    field: 'modified_before',
    label: 'Modified Before',
    type: FILTER_TYPES.DATE,
  },
  { ...PAGE_SIZE_FILTER },
];
